import { EssentialCardItem } from '@msc-b2c/interfaces/types';
import styles from './essentialscarousel.module.scss';
import { useNavigate } from 'react-router-dom';
import { Image } from '@msc-b2c/shared-components';
import { triggerClickCtaEvent } from '../utils/myAreaAnalytics';
import { getObsPlaceholderImagePath, handleKeyDown } from '@msc-b2c/shared-utils';
import { getContainerInfo } from '../utils/analyticsUtils';

const EssentialsCarouselCard = ({
  cardLabel,
  imageUrl,
  imageAlt,
  cardLink,
  cardIndex,
}: EssentialCardItem) => {
  const navigate = useNavigate();
  const onClick = () => {
    const container = document.querySelector('.essentialscarousel');

    triggerClickCtaEvent({
      cta_dest_link: cardLink.url,
      click_main_name: `${cardLabel}`,
      container_info: getContainerInfo(container),
      element_position: `Save on cruise essentials - ${cardLabel}`,
      element_type: 'carousel',
      click_location: `${cardIndex + 1}`,
    });
    cardLink.valid &&
      navigate(`/${cardLink.url}${window.location.href.includes('.html') ? '.html' : ''}`);
  };

  return (
    <div
      role="button"
      tabIndex={0}
      aria-label={cardLabel}
      onClick={onClick}
      onKeyDown={(event) => handleKeyDown(event, onClick)}
      className={styles.cardContainer}
    >
      <Image
        src={imageUrl ?? ''}
        alt={imageAlt ?? ''}
        placeholderImagePath={getObsPlaceholderImagePath()}
        styleOption={styles.cardImage}
      />
      <div className={styles.cardLabel}>{cardLabel}</div>
    </div>
  );
};

export default EssentialsCarouselCard;
